export { ProductMetadata } from './ProductMetadata';
